<template>
    <div v-if="booking.client" class="py-2 px-2 rounded border-1 shadow d-flex align-items-start">
        <ClientAvatar :client="booking.client" class="me-3" size="large"></ClientAvatar>
        <div>
            <div>{{ booking.client.name }}</div>
            <div>
                <small>{{ DateTime.fromISO(booking.date).toLocaleString(DateTime.DATE_MED) }}</small>
            </div>
            <div>
                <small>
                    <strong>Origin: </strong>
                    {{ DateTime.fromISO(booking.planned_origin_time ?? booking.estimated_origin_time).toLocaleString(DateTime.TIME_24_SIMPLE) }} -
                    {{ booking.origin.fullAddress }}
                </small>
            </div>
            <div>
                <small>
                    <strong>Destination: </strong>
                    {{ DateTime.fromISO(booking.planned_destination_time ?? booking.estimated_destination_time).toLocaleString(DateTime.TIME_24_SIMPLE) }} -
                    {{ booking.destination.fullAddress }}
                </small>
            </div>
        </div>
    </div>
</template>

<script setup>
import {DateTime} from "luxon";
import ClientAvatar from "@components/Clients/ClientAvatar.vue";

const props = defineProps({
    booking: {
        type: Object,
        required: true
    }
})

</script>

<style scoped>

</style>
